export function getAll(tableRef) {
    return tableRef.get().then(sn => sn.docs.map(d => ({id: d.id, ...d.data()})))
}
